var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown-button"},[_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }